const tagRegExp = /:(.+)/;

export const getTagTitle = tag => tag.split(tagRegExp)[1]?.trim();
export const getTagCategory = tag => tag.split(tagRegExp)[0]?.slice(1).trim();
